/** Años disponibles en tablas y gráficos PyG analítico. */
export const PYG_AVAILABLE_YEARS = [2023, 2024, 2025, 2026];

export const DEFAULT_PYG_COMPARE_YEARS = [2024, 2025, 2026];

export const MIN_PYG_COMPARE_YEARS = 2;
export const MAX_PYG_COMPARE_YEARS = 4;

/** @deprecated Usar DEFAULT_PYG_COMPARE_YEARS */
export const PYG_ANALITICO_COMPARE_YEARS = DEFAULT_PYG_COMPARE_YEARS;

export const normalizeCompareYears = (selected) => {
  const nums = (Array.isArray(selected) ? selected : [])
    .map((y) => Number(y))
    .filter((y) => PYG_AVAILABLE_YEARS.includes(y));
  const unique = [...new Set(nums)].sort((a, b) => a - b);
  if (unique.length < MIN_PYG_COMPARE_YEARS) return [...DEFAULT_PYG_COMPARE_YEARS];
  if (unique.length > MAX_PYG_COMPARE_YEARS) return unique.slice(0, MAX_PYG_COMPARE_YEARS);
  return unique;
};

export const yearChartColor = (theme, index) => {
  const palette = [
    theme.palette.warning.main,
    theme.palette.info.main,
    theme.palette.success.main,
    theme.palette.secondary.main,
  ];
  return palette[index % palette.length];
};
